function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#img-module-hypnosis_svg__clip0_210_42459)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 42.1,
  cy: 61.954,
  r: 12.813,
  fill: "#A779B2"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 40.129,
  cy: 61.954,
  r: 12.813,
  fill: "#91579F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.629 55.06c2.173-8.546 9.789-5.262 9.789-5.262s4.19-11.715 16.829-12.592c12.638-.878 19.523 13.67 18.578 23.739-1.404 14.847-4.779 23.402-18.578 19.741C23.206 78.288 2.334 68.02 5.629 55.06z",
  fill: "#F5D176"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.804 61.417l2.45 6.693",
  stroke: "#170C2C",
  strokeWidth: 1.522,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.593 58.663l6.333-.243M48.41 58.709l-4.315-.367",
  stroke: "#170C2C",
  strokeWidth: 2.283,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.547 64.915c12.83 3.207 11.828-15.77 11.828-15.77 13.547 7.91 26.574 3.154 26.574 3.154s-3.85-21.21-26.835-18.63c-9.553 1.677-17.48 5.62-17.48 18.63 0 4.73-1.972 10.645 5.913 12.616z",
  fill: "#150B2C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.068 39.096a5.71 5.71 0 108.244-7.903 5.71 5.71 0 00-8.244 7.903z",
  fill: "#150B2C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.629 27.842c4.412 4.602 11.72 4.757 16.323.344 4.602-4.412 4.756-11.72.344-16.323-4.412-4.602-11.72-4.757-16.323-.344C.371 15.93.216 23.239 4.629 27.842z",
  fill: "#150B2C"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 14.499,
  cy: 61.954,
  r: 12.813,
  fill: "#91579F"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 13.513,
  cy: 61.954,
  rx: 11.828,
  ry: 12.813,
  fill: "#A779B2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.17 33.371c-17.741-1.97-22.28 8.676-23.655 17.742.657 4.6 6.308 11.04 7.885 0 1.971-13.798 9.856-13.798 15.77-13.798 4.731 0 7.886 4.73 7.886 4.73s1.97 3.155 2.805 4.352c-.41-6.462-3.291-11.68-10.69-13.026z",
  fill: "#A779B2"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 12.53,
  cy: 61.957,
  r: 5.914,
  stroke: "#fff",
  strokeWidth: 1.971
}), /*#__PURE__*/React.createElement("circle", {
  cx: 51.027,
  cy: 25.56,
  r: 3.884,
  fill: "#91579F"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 37.406,
  cy: 19.654,
  r: 3.806,
  fill: "#91579F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.45 19.547l-.09-15.944a1.522 1.522 0 012.122-1.408L53.03 6.716c.554.238.915.78.922 1.382l.198 17.538",
  stroke: "#91579F",
  strokeWidth: 1.522
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M53.388 12.7L40.45 6.611l.853-4.647 12.086 5.409V12.7z",
  fill: "#91579F"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "img-module-hypnosis_svg__clip0_210_42459"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(.507 .943)",
  d: "M0 0h60.493v80.983H0z"
})));

function SvgImgModuleHypnosis(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 82,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,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";
export { SvgImgModuleHypnosis as ReactComponent };